import "./Skills.scss";
import { useTranslation } from "react-i18next";
import skillsData from "../../data/resumeData.json";

const Skills = ()=> {
    const {t} = useTranslation();
    const getRandomColor = () => {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    };
    return (
      <div className="skills">
        <div className="skills__container">
          <div className="skills__title">
            <h3>{t("skillsTitle.title")}</h3>
            <label>{t("skillsTitle.label")}</label>
          </div>
          <div className="skills__content">
            {skillsData.skills.map((skill, index) => (
              <p key={index}>
                <span>{skill.name}</span>
                <div
                  style={{
                    background: "#e0e0e0",
                    width: "100%",
                    height: "1rem",
                    borderRadius: "5px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      background: getRandomColor(),
                      width: skill.level,
                      height: "100%",
                      borderRadius: "5px",
                    }}
                  ></div>
                </div>
              </p>
            ))}
          </div>
        </div>
      </div>
    );
}
export default Skills;